import type { TermsRepositoryPort } from "../ports/terms.repository.port";

export function getPendingTermsUseCase(repository: TermsRepositoryPort) {
  return repository.getPending();
}
